export class ApplicationData {
    constructor(args) {
        this.givenName = args.givenName;
        this.familyName = args.familyName;
        this.email = args.email;
        this.xingMember = args.xingMember;
        this.teamSelection = args.teamSelection;
        this.acceptedTos = args.acceptedTos;
    }
}
//# sourceMappingURL=application-data.js.map